export const LOAD_CURRENT_USER = 'courses/LOAD_CURRENT_USER';
export const LOAD_CURRENT_USER_SUCCESS = 'courses/LOAD_CURRENT_USER_SUCCESS';
export const LOAD_CURRENT_USER_FAILED = 'courses/LOAD_CURRENT_USER_FAILED';
